/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindPrebidImportExcludedAuctionsResponseDto } from '../../models/find-prebid-import-excluded-auctions-response-dto';

export interface FindPrebidImportExcludedAuctions$Params {
  'X-API-Version'?: string;
}

export function findPrebidImportExcludedAuctions(http: HttpClient, rootUrl: string, params?: FindPrebidImportExcludedAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPrebidImportExcludedAuctionsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findPrebidImportExcludedAuctions.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindPrebidImportExcludedAuctionsResponseDto>;
    })
  );
}

findPrebidImportExcludedAuctions.PATH = '/api/prebid-import/excluded-auctions';
